import { FC } from 'react';
import { Bar, Cell } from 'recharts';
import { MetricChartFrame } from './MetricChartFrame';
import { MetricHistoryPoint } from '../useMetricHistory';

interface Props {
  data: MetricHistoryPoint[];
  label: string;
  unit?: string;
  decimals: number;
  color: string;
  /** YYYY-MM-DD — giorno da evidenziare (cella cliccata) */
  highlightDate?: string | null;
  height?: number;
}

/** Chart barre giornaliere — usato per sRPE (stile EffortLoadChart). */
export const MetricBarChart: FC<Props> = ({
  data,
  label,
  unit,
  decimals,
  color,
  highlightDate,
  height,
}) => (
  <MetricChartFrame
    data={data}
    height={height}
    highlightDate={highlightDate}
    highlightColor={color}
    as="bar"
    tooltipFormatter={(value) => [
      `${Number(value).toFixed(decimals)}${unit ? ` ${unit}` : ''}`,
      label,
    ]}
  >
    <Bar dataKey="value" radius={[3, 3, 0, 0]} maxBarSize={22}>
      {data.map((d) => (
        <Cell
          key={d.date}
          fill={color}
          fillOpacity={highlightDate && d.date === highlightDate ? 1 : 0.55}
        />
      ))}
    </Bar>
  </MetricChartFrame>
);
